"use client";

import { GalleryGrid } from "@/components/landing/gallery-grid"
import api from "@/apis"

export default function Gallery() {
  const { data: galleryItems, isLoading } = api.Gallery.Get.useQuery()

  const defaultImages = [
    {
      src: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=600&q=80",
      alt: "Children learning in classroom",
      title: "Education at Our Centers",
      category: "Education",
    },
    // ... keep some defaults as fallback or initial state if needed, or just replace entire array
  ]
  const imagesToDisplay = galleryItems || defaultImages

  return (
    <main className="min-h-screen">
      {/* Header */}
      <section className="bg-gradient-to-br from-primary/10 to-secondary/10 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="mb-6">Gallery</h1>
          <p className="text-xl text-foreground/70">
            See the real impact of your support. Browse our collection of moments from daily life at our centers.
          </p>
        </div>
      </section>

      {/* Gallery */}
      <section className="section-container">
        <div className="max-w-7xl mx-auto">
          <GalleryGrid images={imagesToDisplay} />
        </div>
      </section>
    </main>
  )
}
